// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Window$LiveRoom from "./Window.bs.js";

var Tier = Window$LiveRoom.WindowVariable({
      variantFromJs: Window$LiveRoom.tierFromJs,
      name: "TIER"
    });

var tier = Belt_Option.getWithDefault(Tier.value, "Local");

var isProd = tier === "Prod" || tier === "Staging";

function datadogConfig(env) {
  return {
          token: "pubfc58ecee50fa82fdd9501f5456bb93d5",
          site: "datadoghq.com",
          serviceName: "live-room",
          environment: env
        };
}

var values = tier === "Staging" ? ({
      auth0: {
        audience: "https://customer.api.stg.sothebys.com",
        clientId: "4EBLAcKimTq6d8xwkOmgRYvHfp1LQthH",
        customDomain: "accounts.staging.sothelabs.com",
        redirectUrlPath: "/buy"
      },
      bidclientUrl: "https://staging.sothebys.com",
      brightspotImageUrl: "https://qa.md.sothebys.psdops.com/dam/image/",
      clientapiGraphqlUrl: "https://clientapi.staging.sothelabs.com/graphql",
      clientapiGraphqlSubscriptionsUrl: "wss://clientapi-ws.staging.sothelabs.com/graphql",
      transactionlUrl: "https://staging.sothebys.com/buy/register",
      aemLoginUrl: "https://staging.sothebys.com/api/auth0login?forceLogin=Y&resource=",
      aemRegisterUrl: "https://staging.sothebys.com/api/auth0login?lang=en&forceLogin=Y&tab=signup&resource=",
      datadog: {
        token: "pubfc58ecee50fa82fdd9501f5456bb93d5",
        site: "datadoghq.com",
        serviceName: "live-room",
        environment: "staging"
      }
    }) : (
    tier === "Dev" ? ({
          auth0: {
            audience: "https://customer.api.dev.sothebys.com",
            clientId: "93OtYDvZJOXm2FzwBYZSMhfXLTmzQM2z",
            customDomain: "accounts.dev.sothelabs.com",
            redirectUrlPath: "/buy"
          },
          bidclientUrl: "https://web.dev.sothelabs.com",
          brightspotImageUrl: "https://qa.md.sothebys.psdops.com/dam/image/",
          clientapiGraphqlUrl: "https://clientapi.dev.sothelabs.com/graphql",
          clientapiGraphqlSubscriptionsUrl: "wss://clientapi-ws.dev.sothelabs.com/graphql",
          transactionlUrl: "https://dev.sothebys.com/buy/register",
          aemLoginUrl: "https://staging.sothebys.com/api/auth0login?forceLogin=Y&resource=",
          aemRegisterUrl: "https://staging.sothebys.com/api/auth0login?lang=en&forceLogin=Y&tab=signup&resource=",
          datadog: {
            token: "pubfc58ecee50fa82fdd9501f5456bb93d5",
            site: "datadoghq.com",
            serviceName: "live-room",
            environment: "dev"
          }
        }) : (
        tier === "Local" ? ({
              auth0: {
                audience: "https://customer.api.stg.sothebys.com",
                clientId: "4EBLAcKimTq6d8xwkOmgRYvHfp1LQthH",
                customDomain: "accounts.staging.sothelabs.com",
                redirectUrlPath: "/buy"
              },
              bidclientUrl: "http://local.sothebys.com:3000/",
              brightspotImageUrl: "https://qa.md.sothebys.psdops.com/dam/image/",
              clientapiGraphqlUrl: "https://clientapi.staging.sothelabs.com/graphql",
              clientapiGraphqlSubscriptionsUrl: "wss://clientapi-ws.staging.sothelabs.com/graphql",
              transactionlUrl: "https://staging.sothebys.com/buy/register",
              aemLoginUrl: "https://staging.sothebys.com/api/auth0login?forceLogin=Y&resource=",
              aemRegisterUrl: "https://staging.sothebys.com/api/auth0login?lang=en&forceLogin=Y&tab=signup&resource=",
              datadog: {
                token: "pubfc58ecee50fa82fdd9501f5456bb93d5",
                site: "datadoghq.com",
                serviceName: "live-room",
                environment: "local"
              }
            }) : (
            tier === "Prod" ? ({
                  auth0: {
                    audience: "https://customer.api.sothebys.com",
                    clientId: "LvmVnUg1l5tD5x40KydzKJAOBTXjESPn",
                    customDomain: "accounts.sothebys.com",
                    redirectUrlPath: "/buy"
                  },
                  bidclientUrl: "https://sothebys.com",
                  brightspotImageUrl: "https://dam.sothebys.com/dam/image/",
                  clientapiGraphqlUrl: "https://clientapi.prod.sothelabs.com/graphql",
                  clientapiGraphqlSubscriptionsUrl: "wss://clientapi-ws.prod.sothelabs.com/graphql",
                  transactionlUrl: "https://www.sothebys.com/buy/register",
                  aemLoginUrl: "https://www.sothebys.com/api/auth0login?forceLogin=Y&resource=",
                  aemRegisterUrl: "https://www.sothebys.com/api/auth0login?lang=en&forceLogin=Y&tab=signup&resource=",
                  datadog: {
                    token: "pubfc58ecee50fa82fdd9501f5456bb93d5",
                    site: "datadoghq.com",
                    serviceName: "live-room",
                    environment: "prod"
                  }
                }) : ({
                  auth0: {
                    audience: "https://customer.api.stg.sothebys.com",
                    clientId: "4EBLAcKimTq6d8xwkOmgRYvHfp1LQthH",
                    customDomain: "accounts.staging.sothelabs.com",
                    redirectUrlPath: "/buy"
                  },
                  bidclientUrl: "http://local.sothebys.com:3000/",
                  brightspotImageUrl: "https://qa.md.sothebys.psdops.com/dam/image/",
                  clientapiGraphqlUrl: "http://localhost:8080/graphql",
                  clientapiGraphqlSubscriptionsUrl: "ws://localhost:8080/graphql",
                  transactionlUrl: "https://staging.sothebys.com/buy/register",
                  aemLoginUrl: "https://staging.sothebys.com/api/auth0login?forceLogin=Y&resource=",
                  aemRegisterUrl: "https://staging.sothebys.com/api/auth0login?lang=en&forceLogin=Y&tab=signup&resource=",
                  datadog: {
                    token: "pubfc58ecee50fa82fdd9501f5456bb93d5",
                    site: "datadoghq.com",
                    serviceName: "live-room",
                    environment: "local"
                  }
                })
          )
      )
  );

export {
  Tier ,
  tier ,
  isProd ,
  datadogConfig ,
  values ,
}
/* Tier Not a pure module */
